import {Paycheck} from '../../../common/types';

export const isNewPaycheck = (
  paycheck: Paycheck | undefined,
  lastPaycheck: Paycheck | undefined,
) => {
  const formDate = paycheck?.date;
  const lastDate = lastPaycheck?.date;

  return !formDate || !lastDate ||
    new Date(formDate.year, formDate.month - 1) >
    new Date(lastDate.year, lastDate.month - 1);
};